export const SORTINGDATA = [
  {
    BUBBLE_SORT: {
      name: "BUBBLE SORT",
      time: "n^2",
      space: "1",
      avg: "n^2",
      best: "n",
      inplace: true,
      stable: true,
      class: "comparison",
      method: "exchanging",
      description:
        "Bubble Sort is the simplest sorting algorithm that works by repeatedly swapping the adjacent elements if they are in wrong order.",
      code: `public BubbleSort = (arr: number[]): number[] => {
    for (let i: number = 0; i < arr.length; i++) {
        for (let j: number = 1; j < arr.length - i; j++) {
            if (arr[j] < arr[j - 1]) {
                let temp = arr[j];
                arr[j] = arr[j - 1];
                arr[j - 1] = temp;
            }
        }
    }
    return arr;
};`,
    },
    SELECTION_SORT: {
      name: "SELECTION SORT",
      time: "n^2",
      space: "1",
      avg: "n^2",
      best: "n^2",
      inplace: true,
      stable: false,
      class: "comparison",
      method: "exchanging",
      description:
        "The selection sort algorithm sorts an array by repeatedly finding the minimum element (considering ascending order) from unsorted part and putting it at the beginning. The algorithm maintains two subarrays in a given array.",
      code: `public SelectionSort = (arr: number[]): number[] => {
    for (let i: number = 0; i < arr.length; i++) {
        let largeIndex = 0;
        let unsortedIndex = arr.length - i - 1;
        for (let j: number = 1; j < arr.length - i; j++) {
            if (arr[j] > arr[largeIndex]) {
                largeIndex = j;
            }
        }
        let temp = arr[unsortedIndex];
        arr[unsortedIndex] = arr[largeIndex];
        arr[largeIndex] = temp;
    }
    return arr;
};`,
    },
    INSERTION_SORT: {
      name: "INSERTION SORT",
      time: "n^2",
      space: "1",
      avg: "n^2",
      best: "n",
      inplace: true,
      stable: true,
      class: "comparison",
      method: "exchanging",
      description:
        "Insertion sort is a simple sorting algorithm that works similar to the way you sort playing cards in your hands. The array is virtually split into a sorted and an unsorted part. Values from the unsorted part are picked and placed at the correct position in the sorted part.",
      code: `public InsertionSort = (arr: number[]): number[] => {
    for (let i: number = 1; i < arr.length; i++) {
        let sortedIndex: number = i - 1;
        let unsortedNumber: number = arr[i];
        while (sortedIndex >= 0 && unsortedNumber < arr[sortedIndex]) {
            arr[sortedIndex + 1] = arr[sortedIndex];
            sortedIndex--;
        }
        arr[sortedIndex + 1] = unsortedNumber;
    }
    return arr;
};`,
    },
    SHELL_SORT: {
      name: "SHELL SORT",
      time: "Depends on gap sequence",
      space: "1",
      avg: "n*log(n)^2 or n^(3/2)",
      best: "n",
      inplace: true,
      stable: false,
      class: "comparison",
      method: "exchanging",
      description:
        "ShellSort is mainly a variation of Insertion Sort. In insertion sort, we move elements only one position ahead. When an element has to be moved far ahead, many movements are involved. The idea of shellSort is to allow exchange of far items.",
      code: `public ShellSort = (arr: number[]): number[] => {
    for (
        let gap: number = Math.floor(arr.length / 2);
        gap > 0;
        gap = Math.floor(gap / 2)
    ) {
        for (let i: number = Math.floor(gap); i < arr.length; i++) {
            let temp: number = arr[i];
            let j: number = i;
            for (j = i; j >= gap && temp < arr[j - gap]; j -= gap) {
                arr[j] = arr[j - gap];
            }
            arr[j] = temp;
        }
    }
    return arr;
};`,
    },

    HEAP_SORT: {
      name: "HEAP SORT",
      time: "n*log(n)",
      space: "1",
      avg: "n*log(n)",
      best: "n*log(n)",
      inplace: true,
      stable: false,
      class: "comparison",
      method: "exchanging",
      description:
        "Heap sort can be understood as the improved version of the binary search tree. It does not create a node as in case of binary search tree instead it builds the heap by adjusting the position of elements within the array itself. In which method a tree structure called heap is used where a heap is a type of binary tree.",
      code: `public ShellSort = (arr: number[]): number[] => {
    for (
        let gap: number = Math.floor(arr.length / 2);
        gap > 0;
        gap = Math.floor(gap / 2)
    ) {
        for (let i: number = Math.floor(gap); i < arr.length; i++) {
            let temp: number = arr[i];
            let j: number = i;
            for (j = i; j >= gap && temp < arr[j - gap]; j -= gap) {
                arr[j] = arr[j - gap];
            }
            arr[j] = temp;
        }
    }
    return arr;
};`,
    },
    MERGE_SORT: {
      name: "MERGE SORT",
      time: "n*log(n)",
      space: "n",
      avg: "n*log(n)",
      best: "n*log(n)",
      inplace: false,
      stable: false,
      class: "comparison",
      method: "Merging",
      description:
        "In computer science, merge sort is an efficient, general-purpose, and comparison-based sorting algorithm. Most implementations produce a stable sort, which means that the order of equal elements is the same in the input and output.",
      code: `public MergeSort = async (arr: number[]): Promise<void> => {
  let low: number = 0;
  let high: number = arr.length - 1;
  let temp: number[] = [...arr];
    for (let m: number = 1; m <= high - low; m = 2 * m) {
      for (let i: number = low; i < high; i += 2 * m) {
        let from: number = i;
        let mid: number = i + m - 1;
        let to: number = Math.min(i + 2 * m - 1, high);
        await this.merge(arr, temp, from, mid, to);
      }
    }
  }
      
public merge = async (A: number[], temp: number[], from: number, mid: number, to: number): Promise<void> => {
  let k: number = from;
  let i: number = from;
  let j: number = mid + 1;
  while (i <= mid && j <= to) {
    if (A[i] < A[j]) {
      temp[k++] = A[i++];
    } else {
      temp[k++] = A[j++];
    }
  }
  while (i < A.length && i <= mid) {
    temp[k++] = A[i++];
  }
  for (i = from; i <= to; i++) {
    A[i] = temp[i];
  }
}
      `,
    },
    QUICK_SORT: {
      name: "QUICK SORT",
      time: "n*2",
      space: "1",
      avg: "n*log(n)",
      best: "n*log(n)",
      inplace: true,
      stable: false,
      class: "comparison",
      method: "Partitioning",
      description:
        "Quicksort is a divide-and-conquer algorithm. It works by selecting a 'pivot' element from the array and partitioning the other elements into two sub-arrays, according to whether they are less than or greater than the pivot.",
      code: 
`public quickSort = async (arr: number[], low: number, high: number) => {
  if (low < high) {
    let pi: number = await this.partition(arr, low, high);
    await this.quickSort(arr, low, pi - 1);
    await this.quickSort(arr, pi + 1, high);
  }
}
      
public partition = async (arr: number[], low: number, high: number): Promise<number> => {
  let pivot: number = arr[high];
  let i: number = (low - 1);
  for (let j: number = low; j < high; j++) {
    if (arr[j] < pivot) {
      i++;
      let temp: number = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }
  }
  let temp: number = arr[i + 1];
  arr[i + 1] = arr[high];
  arr[high] = temp;
  return i + 1;
}
      `,
    },
  },
];
